import { render, staticRenderFns } from "./settings-navigation.vue?vue&type=template&id=0c63e610"
import script from "./settings-navigation.vue?vue&type=script&lang=js"
export * from "./settings-navigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports